export default "__VITE_ASSET___nyJ2OvP__"